<template>
  <div class="page-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>
        <span class="page-title">统计表</span>
      </el-breadcrumb-item>
      <el-breadcrumb-item>登录日志</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="page-content" shadow="never">
      <div class="page-actions"></div>
      <reg-list @refresh="refreshList"></reg-list>
    </el-card>
  </div>
</template>
<script>
import './store';
import { mapActions, mapState } from 'vuex';
import RegList from './components/list';

export default {
  name: 'registered',
  components: {
    RegList
  },
  computed: {
    ...mapState('loginLog', ['pagination'])
  },
  methods: {
    ...mapActions('loginLog', ['list']),
    refreshList(data = {}) {
      this.list({
        ...this.pagination,
        ...data
      });
    }
  },
  created() {
    this.list();
  }
};
</script>

<style lang="less" scoped></style>
